const createErrorObject = (error) => {
  return {
    status: error.response?.status || null,
    statusText: error.response?.statusText || '',
    message: error.message,
  };
};

export { createErrorObject };
